import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Kbd } from '../ui/kbd';
import { useOverlays } from './overlay-context';

const ROWS: Array<{ keys: string[]; action: string }> = [
  { keys: ['⌘', 'K'], action: 'Power K: search, create, go to' },
  { keys: ['⌘', '/'], action: 'Show this shortcuts list' },
  { keys: ['S'], action: 'Focus / open state (peek or full page)' },
  { keys: ['P'], action: 'Focus / open priority (peek or full page)' },
  { keys: ['A'], action: 'Focus / open assignees (peek or full page)' },
  { keys: ['I'], action: 'Focus title (peek or full page)' },
  { keys: ['L'], action: 'Focus / open labels (peek or full page)' },
  { keys: ['Esc'], action: 'Close peek and return focus to the row' },
  { keys: ['Click'], action: 'Open peek' },
  { keys: ['⌘', 'click'], action: 'Open full page in a new tab' },
  { keys: ['Enter'], action: 'Quick-add a work item on the backlog' },
  { keys: ['E'], action: 'Wiki: edit the open page' },
  { keys: ['C'], action: 'Wiki: create a page under the open page' },
  { keys: ['⌘', 'S'], action: 'Wiki editor: update the page' },
  { keys: ['⌘', '⇧', 'E'], action: 'Wiki editor: cycle Source / Split / Preview' },
  { keys: ['Esc'], action: 'Wiki editor: close (asks before discarding edits)' },
];

export default function ShortcutsDialog() {
  const { shortcutsOpen, setShortcutsOpen } = useOverlays();
  return (
    <Dialog open={shortcutsOpen} onOpenChange={setShortcutsOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Keyboard shortcuts</DialogTitle>
        </DialogHeader>
        <ul className="space-y-2 text-sm">
          {ROWS.map((row) => (
            <li key={row.action} className="flex items-center justify-between gap-4">
              <span className="flex items-center gap-1">
                {row.keys.map((key) => (
                  <Kbd key={key}>{key}</Kbd>
                ))}
              </span>
              <span className="text-right text-muted-foreground">{row.action}</span>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
}
